/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteLeadAssignment200Response
 */
export interface DeleteLeadAssignment200Response {
    /**
     * 
     */
    data: object;
}

/**
 * Check if a given object implements the DeleteLeadAssignment200Response interface.
 */
export function instanceOfDeleteLeadAssignment200Response(value: object): value is DeleteLeadAssignment200Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function DeleteLeadAssignment200ResponseFromJSON(json: any): DeleteLeadAssignment200Response {
    return DeleteLeadAssignment200ResponseFromJSONTyped(json, false);
}

export function DeleteLeadAssignment200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteLeadAssignment200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'],
    };
}

export function DeleteLeadAssignment200ResponseToJSON(json: any): DeleteLeadAssignment200Response {
    return DeleteLeadAssignment200ResponseToJSONTyped(json, false);
}

export function DeleteLeadAssignment200ResponseToJSONTyped(value?: DeleteLeadAssignment200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'],
    };
}

